import {SimplePresentation, SimplePresentationRunnerController} from "../../SimplePresentationRunner";
import {gsap} from "gsap";
import {XwaysHoarder2} from "../../XwaysHoarder2";
import {WinConfig, WinConfigUtil} from "../../utils/WinConfigUtil";
import {BasicSymbol} from "../../reels/symbols/BasicSymbol";
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";
import {XwaysHoarder2Sound} from "../../sound/XwaysHoarder2Sound";
import {Reel} from "../../reels/Reel";
import {SimpleReelModelSymbolData} from "../../../core/reel/simplereel/SimpleReelModel";


export class BigWin implements SimplePresentation {

    name: string = "BigWin";

    constructor() {
    }

    shouldRun(): boolean {
        return XwaysHoarder2.model.data.betWayWins.length > 0 && XwaysHoarder2.model.isBigWin;
    }

    start(controller: SimplePresentationRunnerController): void {
        const tl: gsap.core.Timeline = gsap.timeline({
            onComplete: () => {
                controller.setSkipCallback();
                controller.finish();
            }
        });
        const isBigWin = XwaysHoarder2.model.winRatio >= 15;
        const belowStake = XwaysHoarder2.isWinBelowStake();

        const multiplier = 1;
        let winConfigs: WinConfig[] = [];
        for (let i: number = 1; i <= multiplier; i++) {
            const startRatio = XwaysHoarder2.model.winRatio * (i - 1);
            const endRatio = XwaysHoarder2.model.winRatio * i;

            winConfigs = winConfigs.concat(WinConfigUtil.getBigWinLevels(startRatio, endRatio, i, i == multiplier));

        }

        //const lastLevelName = winConfigs[winConfigs.length - 1].name;
        const lastLevelName = winConfigs[winConfigs.length - 1].name;
        if (isBigWin) {
            //This makes sure that the last bigwin level is played in full duration but only to the win amount. With the multipliers spaced out based on the multiplier ratio.
            let lastLevelConfigs = this.getAllConfigsForLevel(lastLevelName, winConfigs);
            for (let config of lastLevelConfigs) {
                config.durationRatio = config.calculateDurationNew(lastLevelConfigs[0].fromRatio, lastLevelConfigs[lastLevelConfigs.length - 1].toRatio);
            }
        }


        // BW stUfF
        let prevConf;
        let cntr: number = 0;
        let currentlevel: number = 1;
        let winConfigCopy:WinConfig[]=JSON.parse(JSON.stringify(winConfigs));

        while (winConfigCopy.length > 0) {
            const config: WinConfig = winConfigCopy.shift()!;
            let levelStartTime: number = tl.duration();
            if (prevConf && prevConf.name == config.name) {
                delete config.sound;
                delete config.anim;
            }
            if (prevConf && prevConf.multiplier == config.multiplier) {
                config.newMultiplier = false;
            }

            const labelName = config.name + "_x" + config.multiplier;

            tl.add(() => {
                controller.setSkipCallback(() => {
                    tl.seek(labelName, false);
                    let Lvl: number = JSON.parse(JSON.stringify(config.particleLevel)) - 1;
                    XwaysHoarder2Sound.stopSound(XwaysHoarder2Sound.BIGWIN_LEVELS[Lvl]);
                });
            }, levelStartTime);

            tl.add(this.getBigWinLevel(config, XwaysHoarder2.model.gameData.playedBetValue, cntr, winConfigCopy.length == 0), levelStartTime);
            tl.addLabel(labelName);
            prevConf = config;
            cntr += 2;
        }


        //tl.add(XwaysHoarder2.winView.getCountUpScaleAnimation(0, XwaysHoarder2.model.gameData.totalSpinWinnings, tl.duration(), 0.4, lastLevelConfig.textScale), 0);
        tl.addLabel("ending");
        tl.add(() => controller.setSkipCallback());

        if (!XwaysHoarder2.model.data.brokeTheBank) {

            const useTotalWin = XwaysHoarder2.model.gameData.accumulatedRoundWin != XwaysHoarder2.model.gameData.totalSpinWinnings || XwaysHoarder2.model.data.mode != GameMode.NORMAL;
            const stayDuration = isBigWin ? 2 : 1;
            tl.add(() => XwaysHoarder2.keypadPlugin.setWin(XwaysHoarder2.model.gameData.accumulatedRoundWin, useTotalWin, XwaysHoarder2.isWinBelowStake()));

            tl.add(XwaysHoarder2.winView.getBigWinEnd(stayDuration));
            tl.add(XwaysHoarder2.winView.setWaysWonText(true), "<");


            tl.add(XwaysHoarder2.winView.getWinCountUpEnd(XwaysHoarder2.model.gameData.totalSpinWinnings, stayDuration), "<");
            tl.add(() => {
                XwaysHoarder2.darkOverlay.hideOverlay(0.2);
                XwaysHoarder2.winView.getWinCountUpFade(XwaysHoarder2.model.gameData.totalSpinWinnings, stayDuration * 0.5);
            });

            XwaysHoarder2.reelView.reels.forEach((reel: Reel, index: number) => {

                reel.model.symbols.forEach((sym: SimpleReelModelSymbolData, symId: number) => {
                    tl.add((<BasicSymbol>sym.positionable).hideNoWinOverlay(0.3), "<");
                })
            })
        } else {
            tl.add(() => {
                XwaysHoarder2Sound.playTrack(XwaysHoarder2Sound.CAP_COUNT_UP);
                XwaysHoarder2Sound.fadeMusic(0, 100);
                this.cap_tl = gsap.timeline().add(() => {
                    XwaysHoarder2Sound.playTrack(XwaysHoarder2Sound.CAP_LOOP, undefined, 100);
                }, 12.5);
            });
            tl.add(XwaysHoarder2.winView.showWinCap());
            tl.add(XwaysHoarder2.winView.getWinCountUp(winConfigs[winConfigs.length-1].toRatioDefault * XwaysHoarder2.model.data.playedBetValue, XwaysHoarder2.model.data.accumulatedRoundWin, 12, 0, new PIXI.Point(360, 570), 1, false), "<");
            tl.add(XwaysHoarder2.winView.hideBigwin(),"<2");

            tl.add(() => {
                controller.setSkipCallback(() => {
                    XwaysHoarder2Sound.playTrack("capCountupSkip");
                    XwaysHoarder2Sound.fadeOutAndStopSound({
                        name: XwaysHoarder2Sound.CAP_COUNT_UP,
                        to: 0,
                        duration: 0.05
                    });
                    this.cap_tl!.kill();
                    this.cap_tl = gsap.timeline().add(() => {
                        XwaysHoarder2Sound.playTrack(XwaysHoarder2Sound.CAP_LOOP, undefined, 100);
                    }, 3.75);
                    tl.seek("MAX_WIN_END", false);
                })
            }, '<');
            tl.addLabel("MAX_WIN_END", '<6.75');
            tl.add(() => { controller.setSkipCallback() }, '<6.75');

            tl.to(this,{duration:1.5});
            tl.add(() => {
                XwaysHoarder2.winView.getWinCountUpFade(XwaysHoarder2.model.gameData.totalSpinWinnings, 0.5);
            });
            tl.add(XwaysHoarder2.winView.showWinCapTimes());
        }
    }

    private cap_tl: gsap.core.Timeline | null;


    private getAllConfigsForLevel(levelName: string, winConfigs: WinConfig[]) {
        const result = [];
        for (let conf of winConfigs) {
            if (conf.name == levelName) {
                result.push(conf);
            }
        }
        return result;
    }

    private getBigWinLevel(bigWinConfig: WinConfig, playedBetValue: number, level: number, lastLevel: boolean): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline();
        let playCountupTo: number = bigWinConfig.toRatio * playedBetValue;
        if (lastLevel) {
            if (XwaysHoarder2.model.data.brokeTheBank) {
                playCountupTo = bigWinConfig.toRatioDefault * XwaysHoarder2.model.data.playedBetValue;
            }
        }
        const countUp = XwaysHoarder2.winView.getWinCountUp(bigWinConfig.fromRatio * playedBetValue, playCountupTo, bigWinConfig.duration * bigWinConfig.durationRatio, 0, new PIXI.Point(360, 570), 1, false);

        tl.add(countUp);

        if (bigWinConfig.sound && bigWinConfig.sound.start) {
            tl.add(() => {
                XwaysHoarder2Sound.playTrack(bigWinConfig.sound!.start!);
            }, 0)
        }

        if(level===0){
          tl.add(XwaysHoarder2.darkOverlay.addOverlay(),0);
        }

        if (bigWinConfig.anim) {
            tl.add(XwaysHoarder2.winView.getBigWinAnimation(level), 0);
        }

        return tl;
    }

}